import axios from "axios";
import {
  getDeleteOptionsObject,
  getOptionsObject,
  getPostOptionsObject,
  getPutOptionsObject,
  isAEMAuthor,
  isLocalhost
} from "./api";
import fixtureData from "../fixtures/index";

export const getApi = async (api,quaryParam) => {
  const getApi = getOptionsObject(api,quaryParam);

  if(isLocalhost() || isAEMAuthor()){
    let data = fixtureData[getApi.url];
    return data;
  }

  const response = await axios(getApi)
  return response?.data;
}

export const postApi = async (api,quaryParam,requestBody) => {
  const getApi = getPostOptionsObject(api,quaryParam,requestBody);

  if(isLocalhost() || isAEMAuthor()){
    let data = fixtureData[getApi.url];
    return data;
  }

  const response = await axios(getApi)
  return response?.data;
}

export const putApi = async (api,quaryParam,requestBody) => {
  const getApi = getPutOptionsObject(api,quaryParam,requestBody);

  if(isLocalhost() || isAEMAuthor()){
    let data = fixtureData[getApi.url];
    return data;
  }

  const response = await axios(getApi)
  return response?.data;
}

export const deleteApi = async (api,queryParam,requestBody) => {
  const deleteApi = getDeleteOptionsObject(api,queryParam,requestBody);

  if(isLocalhost() || isAEMAuthor()){
    let data = fixtureData[deleteApi.url];
    return data;
  }

  const response = await axios(deleteApi)
  return response?.data;
}
